import { render, staticRenderFns } from "./CompetencyPercentileRadar.vue?vue&type=template&id=a7248afc&scoped=true&"
import script from "./CompetencyPercentileRadar.vue?vue&type=script&lang=js&"
export * from "./CompetencyPercentileRadar.vue?vue&type=script&lang=js&"
import style0 from "./CompetencyPercentileRadar.vue?vue&type=style&index=0&id=a7248afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7248afc",
  null
  
)

export default component.exports